import Kyc from "./Kyc";
export default Kyc;
